import { render, staticRenderFns } from "./AccidentRule.vue?vue&type=template&id=1c3dcb6a&scoped=true"
import script from "./AccidentRule.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccidentRule.vue?vue&type=style&index=0&id=1c3dcb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3dcb6a",
  null
  
)

export default component.exports